import { UserRole } from '@/types'

export const hasRole = (userRole: UserRole | null, allowedRoles: UserRole[]): boolean => {
  if (!userRole) return false
  return allowedRoles.includes(userRole)
}

export const isAdmin = (role: UserRole | null): boolean => {
  return role === UserRole.ADMIN
}

export const isTeacher = (role: UserRole | null): boolean => {
  return role === UserRole.TEACHER
}

export const isStudent = (role: UserRole | null): boolean => {
  return role === UserRole.STUDENT
}

export const isParent = (role: UserRole | null): boolean => {
  return role === UserRole.PARENT
}

export const getRoleDisplayName = (role: UserRole): string => {
  const roleNames: Record<UserRole, string> = {
    [UserRole.ADMIN]: 'Administrator',
    [UserRole.TEACHER]: 'Teacher',
    [UserRole.STUDENT]: 'Student',
    [UserRole.PARENT]: 'Parent',
  }
  return roleNames[role] || role
}
